import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Planzone, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editAllocationWarning(
    request: Boundaries["editAllocationWarning"]["request"],
  ): void;
}

function useEditAllocationWarning(planzone: Identifiable<Planzone>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditAllocationWarningRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditAllocationWarningRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditAllocationWarningRequestFailure(planzone),
    ),
    editAllocationWarning: core.editAllocationWarning,
  };
}

export { useEditAllocationWarning };
